import { Helmet } from "react-helmet";
import Header from "../../../../Components/Header";
import Viewpurchase from './Viewpurchase';

function EditPurchaseOrder() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
            <Helmet>
        <title>Purchase Order - View</title>
      </Helmet>
      <Header />
      <div className="container-fluid maindiv d-flex flex-column" style={{flexGrow:'1'}}>
      <Viewpurchase/>
      </div>
    </div>
  )
}

export default EditPurchaseOrder
